import NavBar from '../../components/nav-bar/nav-bar'
import translate from '../../i18n'
import { Card, Space } from 'antd'
import { Outlet } from 'react-router-dom'
import { useLocation } from 'react-router-dom'

const FeatureFlagContainer = () => {
  const location = useLocation()

  const getNavBarTitle = () => {
    const pathName = location.pathname
    if (pathName.match(/^\/feature-flags\/[0-9]+\/edit$/)) {
      return translate('navBar.editFeatureFlag')
    }

    if (pathName.match(/^\/feature-flags\/[0-9]+$/)) {
      return translate('navBar.viewFeatureFlag')
    }

    return translate('navBar.featureFlagsTitle')
  }

  return (
    <Space className="dashboard-wrapper" orientation="vertical">
      <NavBar title={getNavBarTitle()}></NavBar>
      <Card>
        <Outlet />
      </Card>
    </Space>
  )
}

export default FeatureFlagContainer
